import {Injectable} from '@angular/core';
import {AppAlertService} from './app-alert.service';
import {SubtitlesService} from './subtitles.service';
import {SendDataService} from './send-data.service';
import {ParametersService} from './parameters.service';
import {ControlService} from "./tiles";
import * as _ from 'lodash';
import {
    MenuElementType107,
    MenuElementType108,
    MenuElementType1_5
} from "../models";

@Injectable({
    providedIn: 'root'
})
export class TimeDateService {
    date: string = '';
    dateStart: string = '';
    dateEnd: string = '';

    constructor(
        public control: ControlService,
        private appAlert: AppAlertService,
        private subtitles: SubtitlesService,
        private sendData: SendDataService,
        private parameters: ParametersService
    ) {
        this.control.time = {
            defaultHour: 0,
            defaultMinute: 0,
            hour: 0,
            maxHour: 0,
            maxTime: 0,
            minTime: 0,
            minute: 0,
        }
    }

    double(element: number): string {
        return ('0' + element).slice(-2);
    }

    setTimeValue(): void {
        const elementVal = this.control.elementVal.getValue() as MenuElementType1_5;
        const params = elementVal.params;
        if (params) {
            this.control.time.hour = Math.floor(params.value / 60);
            this.control.time.minute = params.value % 60;
            this.control.time.defaultHour = Math.floor(params.default / 60);
            this.control.time.defaultMinute = params.default % 60;
            this.control.time.minTime = params.min;
            this.control.time.maxTime = params.max;
            this.control.time.maxHour = Math.floor(params.max / 60);
        }
    }

    setDefaultTime(): void {
        this.control.time.hour = this.control.time.defaultHour;
        this.control.time.minute = this.control.time.defaultMinute;
    }

    returnTime(): void {
        const data = this.control.time.hour * 60 + this.control.time.minute;
        const elementVal = this.control.elementVal.getValue() as MenuElementType1_5;
        elementVal.params.value = data;
        this.control.elementVal.next(elementVal);
        this.control.returnVal(data);
    }

    changeHourMinute(type: string, val: number): void {
        let hour = this.control.time.hour;
        let minute = this.control.time.minute;

        if (type === 'hour') {
            hour += val;
        } else if (type === 'minute') {
            minute += val;
        }

        let time = hour * 60 + minute;
        time = Math.max(this.control.time.minTime, Math.min(time, this.control.time.maxTime));

        this.control.time.hour = Math.floor(time / 60);
        this.control.time.minute = time % 60;
    }

    setDatePicker(): void {
        const elementVal = this.control.elementVal.getValue() as MenuElementType107
        const params = elementVal.params;
        if (params) {
            this.control.date = `${params.year}-${this.double(params.month)}-${this.double(params.day)}`;
        }
    }

    setDatePickers(): void {
        const elementVal = this.control.elementVal.getValue() as  MenuElementType108;
        const params = elementVal.params;
        const now = new Date();

        this.dateStart = params?.startDay >= 0 && params?.startMonth >= 0 && params?.startYear > 0
            ? `${params.startYear}-${this.double(params.startMonth)}-${this.double(params.startDay)}`
            : this.formatDate(now);

        this.dateEnd = params?.endDay >= 0 && params?.endMonth >= 0 && params?.endYear > 0
            ? `${params.endYear}-${this.double(params.endMonth)}-${this.double(params.endDay)}`
            : this.formatDate(new Date(now.getTime() + 86400000)); // Add 1 day
    }

    changeDate(type: string): void {
        let dateStart = this.parseDate(this.dateStart);
        let dateEnd = this.parseDate(this.dateEnd);
        let currentDate = new Date();
        let tempDate: Date;

        if (type === 'start') {
            if (dateStart >= dateEnd) {
                tempDate = _.cloneDeep(dateStart);
                dateEnd = new Date(tempDate.setDate(tempDate.getDate() + 1));
                this.dateEnd = this.formatDate(dateEnd);
            }
        } else if (type === 'end') {
            if (dateEnd <= dateStart) {
                tempDate = _.cloneDeep(dateEnd);
                dateStart = new Date(tempDate.setDate(tempDate.getDate() - 1));
                this.dateStart = this.formatDate(dateStart);
            }
        }

        this.dateStart = dateStart < currentDate
            ? this.formatDate(currentDate)
            : this.formatDate(dateStart);

        tempDate = _.cloneDeep(currentDate);
        const nextDay = new Date(tempDate.setDate(tempDate.getDate() + 1));
        this.dateEnd = dateEnd <= currentDate
            ? this.formatDate(nextDay)
            : this.formatDate(dateEnd);

        currentDate = new Date(currentDate.setDate(currentDate.getDate() - 1));

        if ((dateStart < currentDate) || (dateEnd < currentDate)) {
            const message = `<div class="text-align-center">${this.subtitles.setSubtitle(4387)}</div>`;
            this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475), null, false, null);
        }
    }

    setDateNow(): void {
        this.control.date = this.formatDate(new Date());
    }

    private parseDate(s: string): Date {
        const tokens = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
        return tokens ? new Date(parseInt(tokens[1]), parseInt(tokens[2]) - 1, parseInt(tokens[3])) : new Date();
    }

    formatDate(date: Date): string {
        return date ? `${date.getFullYear()}-${this.double(date.getMonth() + 1)}-${this.double(date.getDate())}` : '';
    }

    returnDate(): void {
        const [year, month, day] = this.control.date.split('-').map(Number);
        const dataToSend = {
            menuType: this.control.elementVal.getValue()?.menuType,
            ido: this.control.elementVal.getValue()?.id,
            data: {
                year,
                month,
                day,
                pin: ""
            }
        };

        if (this.control.pin) {
            dataToSend.data.pin = this.control.pin;
            this.control.pin = '';
        }

        this.sendData.sendControlData(dataToSend);

        if (!this.parameters.demoAccount()) {
            const element = this.control.element.getValue() as MenuElementType107;
            if (element) {
                element.params.day = day;
                element.params.month = month;
                element.params.year = year;
                element.duringChange = 't';
                this.control.setsNewValue = this.control.elementVal.getValue()?.id ?? 0;
                this.control.hideControl();
            }
        }
    }

    returnPickersDate(reset: boolean): void {
        const dataToSend = {
            menuType: this.control.elementVal.getValue()?.menuType,
            ido: this.control.elementVal.getValue()?.id,
            data: {
                date_start: reset ? {
                    year: -1,
                    month: -1,
                    day: -1
                } : this.parseDateParts(this.dateStart),
                date_end: reset ? {
                    year: -1,
                    month: -1,
                    day: -1
                } : this.parseDateParts(this.dateEnd),
                pin: ""
            }
        };

        if (this.control.pin) {
            dataToSend.data.pin = this.control.pin;
            this.control.pin = '';
        }

        this.sendData.sendControlData(dataToSend);

        if (!this.parameters.demoAccount()) {
            const dateStart = reset ? {
                year: -1,
                month: -1,
                day: -1
            } : this.parseDateParts(this.dateStart);
            const dateEnd = reset ? {
                year: -1,
                month: -1,
                day: -1
            } : this.parseDateParts(this.dateEnd);

            const element = this.control.element.getValue() as MenuElementType108;
            if (element) {
                element.params.startDay = dateStart.day;
                element.params.startMonth = dateStart.month;
                element.params.startYear = dateStart.year;
                element.params.endDay = dateEnd.day;
                element.params.endMonth = dateEnd.month;
                element.params.endYear = dateEnd.year;
                element.duringChange = 't';
                this.control.setsNewValue = this.control.elementVal.getValue()?.id ?? 0;
                this.control.hideControl();
            }
        }
    }

    private parseDateParts(date: string): {
        year: number,
        month: number,
        day: number
    } {
        const [year, month, day] = date.split('-').map((str) => parseInt(str, 10));
        return {year, month, day};
    }
}
